import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

import * as moment from 'moment';

interface PickerMonth {
  index: number;
  shortLabel: string;
  fullLabel: string;
}

const MONTHS_IN_YEAR = 12;

@Component({
  selector: 'gp-hr-calendar-month-picker',
  templateUrl: './hr-calendar-month-picker.component.html',
  styleUrls: ['./hr-calendar-month-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HrCalendarMonthPickerComponent implements OnChanges {

  @Input()
  public selected: Date;

  @Output()
  public monthSelected: EventEmitter<Date> = new EventEmitter<Date>();

  public pickerYear: number;
  public months: PickerMonth[] = [];

  public ngOnChanges(): void {
    const reference = moment(this.selected ?? new Date());
    this.pickerYear = reference.year();
    this.months = Array.from({length: MONTHS_IN_YEAR}, (_, index) => {
      const month = moment(reference).month(index);
      return {index, shortLabel: month.format('MMM'), fullLabel: month.format('MMMM')};
    });
  }

  public changeYear(delta: number): void {
    this.pickerYear += delta;
  }

  public isSelected(monthIndex: number): boolean {
    return !!this.selected
      && this.selected.getFullYear() === this.pickerYear
      && this.selected.getMonth() === monthIndex;
  }

  public selectMonth(monthIndex: number): void {
    this.monthSelected.emit(new Date(this.pickerYear, monthIndex, 1));
  }

  public trackMonth(_: number, month: PickerMonth): number {
    return month.index;
  }
}

